<template>
	<div id="afterSalesRecord">
		<!-- <div class="headbox">
			<el-form inline>
				<el-form-item label="编号:">
					<el-input size="small " v-model="number" placeholder="请输入客户名称" clearable style="width: 150px;"></el-input>
				</el-form-item>
				<el-form-item label="客户名称:">
					<el-input size="small " v-model="name" placeholder="请输入客户名称" clearable style="width: 150px;"></el-input>
				</el-form-item>
				<el-form-item label="产品类型:">
					<el-select size="small" style="width: 140px;" clearable v-model="customer_type" placeholder="请选择">
						<el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.name" />
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" @click="changepage(1)">查询</el-button>
				</el-form-item>
			</el-form>
		</div> -->
		
		<div class="tablebox">
			<el-table v-loading="loading" :data="list" border :header-cell-style="{ background: '#fafafa', color: '#000' }" >
				<el-table-column label="客户全称" prop="customer.name" align="center" width="300"/>
				<el-table-column label="记录内容" prop="content" align="center"/>
				<el-table-column label="添加人" prop="sale.username" align="center" width="200"/>
				<el-table-column label="添加时间" prop="created_at" align="center" width="200"/>
			</el-table>	
		</div>
		
		<div class="pages" v-if="total>10">
			<el-pagination background @current-change="changepage" :current-page="page"
				:page-size="10" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
		</div>
	</div>
</template>

<script>
	import {eltips,setTimeStyle} from '@/util/util.js'
	export default {
		name: "afterSalesRecord",
		data() {
			return {
				loading:false,
				total:0,
				page:1,
				list:[],
				
			};
		},
		created() {
			this.getList()
		},
		methods:{
			changepage(e){
				this.page = e
				this.getList()
			},
			getList(){
				let data = {
					page:this.page,
					name:this.name,
					number:this.number,
					customer_type:this.customer_type,
					type:this.type,
					follow_type:1,
				}
				this.loading = true
				this.axios.get('/api/main/Customrt/SaleLog_list',{params:data}).then(res=>{
					this.loading = false
					if(res.code==200){
						this.total = res.data.total
						this.list = res.data.data
					}else{
						eltips(res.msg,'error')
					}
				})
			}
		}
	};
</script>

<style lang="less" scoped>
	#afterSalesRecord{
		min-height: calc(100vh - 70px);
	}
	
	#afterSalesRecord .headbox /deep/ .el-form-item {
		margin-bottom: 10px !important;
	}
	
	.headbox {
		padding: 10px 20px 0;
		background: #ffffff;
		border-radius: 2px;
	}
	
	.tablebox {
		// margin-top: 10px;
		padding: 10px 20px;
		background: #ffffff;
		.redText{
			color: #FF0000;
		}
	}
	
	.pages {
		text-align: center;
		background: #ffffff;
		padding: 20px 0;
		border-top: 1px solid #ededed;
	}
</style>